import { ROLE } from '~/config/constants'

export default function ({ store, redirect, app }) {
  const user = store.getters['user/getUser']
  
  if (!user || !user.role) {
    redirect('/login')
    return
  }

  const roleId = user.role.roleId
  
  // Blokiraj Team leader (2) i Team member (3)
  if (
    roleId === ROLE.TEAM_LEADER ||
    roleId === ROLE.TEAM_MEMBER
  ) {
    if (process.client && app.$bus) {
      app.$bus.$emit('send-notification', {
        message: 'You do not have permission to access this page.',
        type: 'error',
      })
    }
    redirect('/')
    return
  }
}

